export enum InvoiceStatus {
  Paid = 'PAID',
  Unpaid = 'NOT PAID',
}

export type Invoice = {
  id: string;
  invoiceNumber: string;
  createdAt: Date;
  amount: number;
  status: InvoiceStatus;
};

export type InvoiceFilters = {
  status?: InvoiceStatus;
  createdAfter?: Date;
  createdBefore?: Date;
};
